import React, {Component} from 'react';

import TopMenu from '../TopMenu/TopMenu';
import { AppBar, Toolbar, Typography } from '@mui/material';
TopMenu.muiName = 'IconMenu';

class TopNav extends Component {
	render() {
		const { title, subtitle, updateAppState, showMenuIconButton, iconElementRight, iconElementLeft, ...filteredProps } = this.props; // eslint-disable-line no-unused-vars
		return (
			<div style={{ position: 'sticky', top: '0', zIndex: 2 }}>
				<AppBar position="static" {...filteredProps} >
					<Toolbar color="primary">
						{iconElementLeft}
						<div style={{ flexGrow: 1 }}>
							<Typography
								component="span"
								variant="h6"
								style={{ fontWeight: 400 }}
								color="inherit"
								noWrap
							>
								{title}
							</Typography>
							<Typography
								component="div"
								variant="caption"
								color="inherit"
								noWrap
							>
								{subtitle}
							</Typography>
						</div>
						{iconElementRight}
					</Toolbar>
				</AppBar>
			</div>
		);
	}
}

TopNav.defaultProps = {
	title: '',
	showMenuIconButton: false,
	iconElementRight: null
};

export default TopNav;
